import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import AppHeaderBar from "./AppHeaderBar";
import AppInstallationRow from "./AppInstallationRow";
import AppNavBar from "./AppNavBar";
import Cookies from "js-cookie";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  INSTALLATION_LIST_STALE_KEY,
  isVisibleInInstallationList,
} from "./installation/installationConfigUtils";

const INSTALLATION_SHOW_DETAILS_KEY = "installation_show_schedule_details";

const AppInstallation = ({ setCookies, saveUser }) => {
  const API = process.env.REACT_APP_API_BACKEND;
  const token = Cookies.get("userToken");
  const { t } = useTranslation();
  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const [showScheduleDetails, setShowScheduleDetails] = useState(() => {
    const stored = localStorage.getItem(INSTALLATION_SHOW_DETAILS_KEY);
    return stored === "1";
  });

  useEffect(() => {
    localStorage.setItem(
      INSTALLATION_SHOW_DETAILS_KEY,
      showScheduleDetails ? "1" : "0",
    );
  }, [showScheduleDetails]);

  const fetchData = useCallback(async () => {
    if (!token) {
      return;
    }
    const response = await axios.get(`${API}cameras`, {
      headers: { authorization: `Bearer ${token}` },
      params: {
        all: false,
        keywordFilter: "",
        sortByField: "name",
        orderSortByField: 1,
        batteryLevelFilter: [0, 100],
        startDateFilter: null,
        stopDateFilter: null,
        page: 1,
        limit: 20,
      },
    });

    if (response.status === 200) {
      setTableData(
        response.data.dataCamerasList.filter(isVisibleInInstallationList),
      );
      sessionStorage.removeItem(INSTALLATION_LIST_STALE_KEY);
    }
  }, [API, token]);

  useEffect(() => {
    if (location.pathname !== "/app/installation") {
      return;
    }
    fetchData();
  }, [
    location.pathname,
    location.key,
    location.state?.refreshInstallationList,
    fetchData,
  ]);

  const sortedData = tableData
    .filter(isVisibleInInstallationList)
    .sort((a, b) =>
      (a?.address?.[0]?.name || "").localeCompare(b?.address?.[0]?.name || ""),
    );

  const groupedByAddress = sortedData.reduce((acc, item) => {
    let address = "-";
    if (item?.address?.length > 0) {
      address = item.address[0].name;
    } else if (item.name?.includes("mobile")) {
      address = "Mobile";
    }

    if (!acc[address]) {
      acc[address] = [];
    }

    acc[address].push(item);
    return acc;
  }, {});

  return (
    <div className="installation-list-page">
      <AppHeaderBar
        title={t("Installation")}
        setCookies={setCookies}
        saveUser={saveUser}
      />
      <div className="installation-list-shell">
        <div className="installation-list-toolbar">
          <button
            type="button"
            className={
              showScheduleDetails
                ? "installation-list-toggle installation-list-toggle-active"
                : "installation-list-toggle"
            }
            onClick={() => setShowScheduleDetails((value) => !value)}
          >
            {showScheduleDetails
              ? t("installation_list_toggle_details_on")
              : t("installation_list_toggle_details_off")}
          </button>
        </div>
        <div className="installation-list">
          {Object.keys(groupedByAddress).map((address) => (
            <section key={address} className="installation-address-group">
              <h2 className="installation-address-heading">
                <FaMapMarkerAlt
                  className="installation-address-heading-icon"
                  aria-hidden
                />
                <span
                  className="installation-address-heading-text"
                  title={address}
                >
                  {address}
                </span>
              </h2>
              <div className="installation-address-cards">
                {groupedByAddress[address].map((item) => (
                  <AppInstallationRow
                    key={item._id}
                    item={item}
                    showScheduleDetails={showScheduleDetails}
                  />
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
      <AppNavBar />
    </div>
  );
};

export default AppInstallation;
